import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { IGetCurriculumDto } from "../../../../@types/curriculum.type";
import { getCurriculumByResourceId } from "../../../../services/api/Curriculum/curriculumService";
import { ChipsSkill } from "../../../UserProfile/components/Chips";
import { CertificationGrid } from "../Grid/Certification";
import { LanguageGrid } from "../Grid/Language";


interface SkillsResourceProps {
  resourceId: string;
}

export const SkillsResource: React.FC<SkillsResourceProps> = ({
  resourceId
}) => {
  
  const [curriculum, setCurriculum] = useState<IGetCurriculumDto>([]);

  useEffect(() => {
    loadInfo();
  }, []);

  const loadInfo = async () => {
    try {
      const response = (await getCurriculumByResourceId(resourceId)) as IGetCurriculumDto;
      setCurriculum(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className={styles.body}>
        {
          curriculum && curriculum.hardSkills && curriculum.hardSkills.length > 0 &&
          <div className={styles.hardSkills}>
            <h3>Hard Skills</h3>
            <div>
              <ChipsSkill skills={curriculum.hardSkills} type="hardskill" />
            </div>
          </div>
        }
        {
          curriculum && curriculum.softSkills && curriculum.softSkills.length > 0 &&
          <div className={styles.softSkills}>
            <h3>Soft Skills</h3>
            <div>
              <ChipsSkill skills={curriculum.softSkills} type="softskill"/>
            </div>
          </div>
        }
        {
          curriculum && curriculum.experiences && curriculum.experiences.length > 0 &&
          <div className={styles.experiences}>
            <h3>Experiências</h3>
            <div>
              <ChipsSkill skills={curriculum.experiences} type="experiences" />
            </div>
          </div>
        }
        <div className={styles.grids}>
          {
            curriculum && curriculum.certifications &&
            <div className={styles.certifications}>
              <h3>Certificações</h3>
              <div className={`${styles.gridContainer}`}>
                <CertificationGrid certifications={curriculum.certifications} />
              </div>
            </div>
          }

          {
            curriculum && curriculum.languages && curriculum.languages.length > 0 &&
            <div className={styles.languages}>
              <h3>Idiomas</h3>
              <div className={`${styles.gridContainer}`}>
                <LanguageGrid languages={curriculum.languages} />
              </div>
            </div>
          }
        </div>
      </div>
    </>
  );
};
